module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-583-min.8615767c.jpg";